import type { FC } from 'react';
import { CabinetTitlePage } from 'components/layout';
import { EditUser } from 'features/cabinet';
import { Guard, usePermissionGuard } from 'features/login';

const EditUserPage: FC = () => {
  const { accessToChangeUserprofile } = usePermissionGuard();

  return (
    <Guard hasAccess={accessToChangeUserprofile}>
      <CabinetTitlePage title="Users" goBack={'/cabinet/facebook/users'} />
      <EditUser />
    </Guard>
  );
};

export default EditUserPage;
